import { AppContext } from '@/ui/components/Context';
import { useLoadAllTranslations } from '@/ui/hooks/useLoadAllTranslations';
import { initFeatureFlags } from '@juvare/common-js/feature-flags';
import { CommonProvider } from '@juvare/common-web-ui/CommonProvider';
import { NavigationContextProvider } from '@juvare/common-web-ui/NavigationContext';
import { publicDataApi } from '@juvare/platform-sdk-react/ui/apis';
import { settingsReducers } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { AppContextProvider } from '@juvare/platform-sdk-react/ui/providers';
import { appManifestReducers, platformReducers } from '@juvare/platform-sdk-react/ui/stores';
import { configureStore } from '@reduxjs/toolkit';
import React from 'react';
import { Provider } from 'react-redux';

initFeatureFlags({ schemas: __FEATURE_FLAG_SCHEMAS__ });

export const store = configureStore({
    reducer: {
        ...appManifestReducers,
        ...platformReducers,
        ...settingsReducers,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(publicDataApi.middleware),
});

export const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const ready = useLoadAllTranslations();

    return (
        <Provider store={store}>
            <NavigationContextProvider>
                {ready && (
                    <CommonProvider>
                        <AppContextProvider appContext={AppContext}>{children}</AppContextProvider>
                    </CommonProvider>
                )}
            </NavigationContextProvider>
        </Provider>
    );
};
